import config from "./config";

const formatDateTokens = (
  date: Date,
  format?: string,
  options?: { use12HourTime?: boolean }
) => {
  const fmt = format || "MM/DD/YYYY";
  const pad = (n: number) => String(n).padStart(2, "0");
  const hours = date.getHours();
  const normalizedHour = hours % 12 || 12;
  const ampm = hours < 12 ? "AM" : "PM";
  const map: Record<string, string> = {
    YYYY: String(date.getFullYear()),
    YY: pad(date.getFullYear() % 100),
    MM: pad(date.getMonth() + 1),
    DD: pad(date.getDate()),
    HH: pad(options?.use12HourTime ? normalizedHour : hours),
    hh: pad(options?.use12HourTime ? normalizedHour : hours),
    mm: pad(date.getMinutes()),
    ss: pad(date.getSeconds()),
    A: ampm,
    a: ampm.toLowerCase(),
  };
  return fmt.replace(/YYYY|YY|MM|DD|HH|hh|mm|ss|A|a/g, (token) => map[token] ?? token);
};

// function for check with regex if the date is in the correct format 1900-01-01T00:00:00
export const checkDate = (date: string) => {
  for (let i = 0; i < config.dateRegex.length; i++) {
    const regex = new RegExp(config.dateRegex[i]);
    if (regex.test(date)) {
      return true;
    }
  }
  return false;
};

export const transformDate = (
  d: string | number,
  options?: { generatedDateFormat?: string; use12HourTime?: boolean }
) => {
  if (checkDate(d.toString())) {
    const date = new Date(d);
    const format =
      options?.generatedDateFormat ||
      config.generatedDateFormat ||
      "MM/DD/YYYY";
    const use12HourTime =
      options?.use12HourTime ?? config.use12HourTime ?? false;

    if (format === "MM/DD/YYYY" && !/YYYY|YY|MM|DD|HH|hh|mm|ss|A|a/.test(format)) {
      const returndate = [
        date.getMonth() + 1,
        date.getDate(),
        date.getFullYear(),
      ].join("/");
      return returndate;
    }

    return formatDateTokens(date, format, { use12HourTime });
  }
  return d;
};
